














import { Vue, Component } from 'vue-property-decorator';
import CamaraRegistro from '@/pantallas/Camaras/Registro/CamaraRegistro.vue';

@Component({
  components: { RegistroComponent: CamaraRegistro },
})
export default class CamaraRegistroPantalla extends Vue {}
